import React, { useEffect, useRef } from 'react';

import { StudentScrollGuidedDialog } from '../../../GuidedTour/student/StudentScrollGuidedDialog';
import { useScrollGuidedTour } from '../../../hooks/useScrollGuidedTour';
import { useSwitch } from '../../../hooks/useSwitch';
import classNames from 'classnames';

import './ScrollIndicator.scss';

interface ScrollIndicatorProps {
  isVisible: boolean;
  className?: string;
}

export const ScrollIndicator = ({ isVisible, className }: ScrollIndicatorProps) => {
  const visibleInternal = useSwitch(isVisible);
  const ref = useRef(null);
  const { isShowing } = useScrollGuidedTour();

  useEffect(() => {
    if (isVisible) {
      const timeout = setTimeout(() => {
        visibleInternal.turnOn();
      }, 3000);
      return () => clearTimeout(timeout);
    }
    return;
  }, [isVisible, visibleInternal]);

  if (isVisible && visibleInternal.isOn) {
    return (
      <div className={classNames('scroll-indicator__positioner', className)}>
        <StudentScrollGuidedDialog targetRef={ref}>
          <div className={classNames('scroll-indicator', { 'scroll-indicator--paused': isShowing })} ref={ref}>
            <span />
            <span />
          </div>
        </StudentScrollGuidedDialog>
      </div>
    );
  }
  return null;
};
